import React from "react";
import { Provider } from "react-redux";

interface StoreProviderProps {
  children: React.ReactNode;
}

let globalStore: ReturnType<typeof ReactOnRails.getStore> | null = null;

/**
 *
 * Could use this everywhere but this is a hack for rspec tests, for whatever reason
 * the store is created multiple times instead of being reused which causes sync
 * issues with Header/Sidebar/Main components. Dev/Prod do not have this issue.
 *
 */
const StoreProvider: React.FC<StoreProviderProps> = ({ children }) => {
  if (!globalStore) globalStore = ReactOnRails.getStore("layoutStore");
  return (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    <Provider store={process.env.NODE_ENV === "test" ? globalStore : ReactOnRails.getStore("layoutStore")}>
      {children}
    </Provider>
  );
};

export default StoreProvider;
